import { SVGProps, Ref, forwardRef } from 'react';

export const MinusCircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1M6.5 11.1v1.8h11v-1.8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
MinusCircleFilledSize24Glyph.displayName = 'MinusCircleFilledSize24Glyph';
